export const CommonErrorMessages = {
  PermissionDenied: 'You do not have permission to perform this action.',
  NotAuthorizedPage: 'You do not have permission to view this page.',
  NoAccessAssigned: 'Your role has no menus assigned. Please contact an administrator.',
  ViewPermissionRequired: 'View permission is required before Add, Edit, Delete, Export or Import can be granted.',
  RoleAssignedUsersDeleteBlocked: 'This role is assigned to {count} user(s). Reassign them before deleting.',
  SelectedFileErrorMessage: 'Selected file exceeds the maximum allowed size (10MB).',
  ImagesAllowed: 'Only JPG, JPEG, and PNG image files are allowed.',
  CardImageRequired: 'Card image is required.',
  CardImageSizeInvalid: 'Image size must be 600 x 825 pixels (width x height).',
  ErrorFetchingUser: 'Error fetching user:',
  ExportError: 'Export error:',
  APIError: 'API Error:',
  NoUserFound: 'No users found.',
  NoDataFoundToExport: 'No data found to export.',
  ExportFailed: 'Export failed. Please try again later.',
  UserIDMissingDecryptionFailed: 'User ID missing or decryption failed.',
  NoBindersFound: 'No binders found.',
  FailedToFetchBinders: 'Failed to fetch binders.',
  CardDataNotFound: 'Card data not found.',
  FailedToFetchCards: 'Failed to fetch cards.',
  FailedToFetchCardDetails: 'Failed to fetch card details.',
  CardDetailsNotFound: 'Card details not found.',
  AuthenticationCodeRequired: 'Authentication code is required.',
  AuthenticationCodeVerifiedSuccessfully: 'Authentication code verified successfully.',
  VerificationFailed: 'Verification failed.',
  ErrorFetchingSets: 'Error fetching sets:',
  NoSetsFound: 'No sets found.',
  NoSetsAvailableLoad: 'No sets available to load.',
  UnexpectedResponseFormat: 'Unexpected response format.',
  FetchError: 'Fetch error:',
  PleaseSelectFetch: 'Please select at least one card to fetch.',
  SyncFailed: 'Sync failed. Please try again later.',
  SyncError: 'Sync error:',
  FailedToSyncCards: 'Failed to sync cards',
  SetIdMissing: 'Set ID is missing. Cannot navigate.',
  FailedFetchCardSets: 'Failed to fetch card sets.',
  SetAddedSuccessfully: 'Set added successfully!',
  FailedSaveSet: 'Failed to save set',
  DashboardFetchError: 'Dashboard fetch error:',
  NotificationTitleRequired: 'Notification title is required.',
  NotificationMessageRequired: 'Notification message is required.',
  VaultxBinderRequired: 'VaultX Binder selection is required.',
  SetAndCardRequired: 'Set and Card selection are required.',
  PresetBindersRequired: 'Select Preset Binders is required.',
  AppUsersRequired: 'Select App Users is required.',
  ScreenRequired: 'Select Screen is required.',
  CustomUrlRequired: 'Custom URL is required.',
  ButtonTextRequired: 'Button text is required.',
  FailedToSaveNotification: 'Something went wrong while saving notification.',
  FailedToLoadSets: 'Failed to load sets.',
  FailedToLoadBinders: 'Failed to load VaultX binders.',
  FailedToLoadPresetBinders: 'Failed to load preset binders.',
  FailedToLoadPredefinedTypes: 'Error loading predefined types.',
  NotificationSavedSuccessfully: 'Notification saved successfully',
  NotificationSaveError: 'Notification save error:',
  SetLoadError: 'Set load error:',
  NotificationTitleAndMessageRequired: 'Notification title and message are required.',
  FailedLoadBinders: 'Failed to load binders.',
  BinderFetchError: 'Binder fetch error:',
  NoPresetBindersFound: 'No preset binders found.',
  ErrorFetchingNotification: 'Error fetching notification:',
  FailedLoadNotificationDetails: 'Failed to load notification details.',
  FailedToLoadNotifications: 'Failed to load notifications.',
  InvalidNotificationData: 'Invalid notification data.',
  NotificationDeletedSuccessfully: 'Notification deleted successfully.',
  FailedToDeleteNotification: 'Failed to delete notification.',
  DeleteNotificationError: 'Something went wrong while deleting notification.',
  PageNotFound: 'The page you are looking for does not exist.',
  FailedToLoadPresetDetails: 'Failed to load preset details.',
  FailedToLoadPresetUsers: 'Failed to load user summary.',
  FailedToLoadCustomUsers: 'Failed to load users.',
  FailedToResolveImportedUsers: 'Invalid file format or missing columns.',
  FailedToSavePreset: 'Preset save failed.',
  PresetSaveError: 'Something went wrong while saving preset.',
  PresetLoadError: 'Something went wrong while loading preset.',
  PresetUserLoadError: 'Something went wrong while loading users.',
  FileTypeNotAllowed: 'Only JSON, CSV, or Excel (.xlsx) files are allowed.',
  FileSizeExceeded: 'File size exceeds 5MB limit.',
  PleaseSelectAtLeastOneUser: 'Please select at least one user from the list.',
  ErrorLoadingUsers: 'Error loading users.',
  SomethingWentWrongResolvingUers : 'Something went wrong while resolving users.',
  DeletePresetError: 'Something went wrong while deleting preset.',
  FailedDeletePreset: 'Failed to delete preset.',
  FailedUpdateNFCStatus: 'Failed to update NFC status',
  ErrorSavingBinder: 'Error saving binder',
  FailedToSaveBinder: 'Failed to save binder',
  BinderSavedSuccessfully: 'Binder saved successfully',
  ErrorLoadingBinder: 'Error loading binder',
  FailedToLoadBinder: 'Failed to load binder',
  FailedToLoadPockets: 'Failed to load pockets',
  FailedLoadColors: 'Failed to load colors',
  FailedToLoadNfcUrls: 'Failed to load NFC URLs.',
  ErrorFetchingNfcUrls: 'Error fetching NFC URLs.',
  FailedToAddQuantity: 'Failed to add quantity.',
  InvalidNfcUrl: 'Invalid NFC URL.',
  NfcUrlAlreadyAllocated: 'This NFC URL is already allocated. Deleting it will remove it from the user\'s.',
  FailedToDeleteUrls: 'Failed to delete URL(s).',
  FailedToManufacturedUrls: 'Failed to manufactured NFC URL(s).',
  NoValidUrlsSelected: 'No valid NFC URLs selected for deletion.',
  FileNotFound: 'File not found.',
  FailedDecode: 'Failed to decode/decrypt binderId.',
  ErrorBinderParams: 'Failed to parse binderParams from localStorage:',  
  FailedLoadNFCURLs: 'Failed to load NFC URLs.',
  FailedDeleteColor: 'Failed to delete color.',
  DeleteColorError: 'Something went wrong while deleting color.',
  ErrorSavingColor: 'Error saving color.',
  ErrorLoadingColor: 'Error loading color.',
  PocketsRequired: 'At least one pocket must be selected.',
  FailedToLoadPocketsForColor: 'Failed to load pockets.',
}
